import React from 'react'

const NotFound = () => {
  return (
    <div className='not-found my-5'>
    <div className='container flex align-center justify-center'>
      OOPS! No Such Food Found.
    </div>

  </div>
)   
}

export default NotFound